import { render, staticRenderFns } from "./BotWeddingEventImagesCard.vue?vue&type=template&id=3e7e12b1&scoped=true"
import script from "./BotWeddingEventImagesCard.vue?vue&type=script&lang=ts"
export * from "./BotWeddingEventImagesCard.vue?vue&type=script&lang=ts"
import style0 from "./BotWeddingEventImagesCard.vue?vue&type=style&index=0&id=3e7e12b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e12b1",
  null
  
)

export default component.exports